import './chunk-2452e3d3.js';
import './helpers.js';
import './chunk-8ed29c41.js';
import './chunk-d92f0cd9.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import { B as Button } from './chunk-e7c9b2cb.js';
export { B as BButton } from './chunk-e7c9b2cb.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Button);
  }
};
use(Plugin);

export default Plugin;



//////////////////
// WEBPACK FOOTER
// ./node_modules/buefy/dist/esm/button.js
// module id = null
// module chunks = 